<template>
  <div class="card floating">
    <div class="card-content">
      <p>{{ $t('prompts.archiveMessage') }}</p>
    </div>
    <div class="card-action">
      <button @click="$store.commit('closeHovers')" id ="buttonCancelDelete"
        class="button button--flat button--grey"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')">{{ $t('buttons.cancel') }}</button>
      <button @click="submit"
        class="button button--flat button--red" id ="buttonDelete"
        :aria-label="$t('buttons.store')"
        :title="$t('buttons.store')">{{ $t('buttons.store') }}</button>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from 'vuex';

export default {
  name: 'archive-shared-drive',
  mounted () {
    this.setIsPrompt(true);
    this.setIsRename(true);
  },
  computed: {
    ...mapGetters(['isListing', 'selectedCount', 'isSharedDrive', 'isLogged']),
    ...mapState(['req', 'selected', 'isRename', 'handleRecord', 'linkSharedDrive'])
  },
  methods: {
    ...mapMutations(['closeHovers', 'setIsPrompt', 'setIsRename', 'setParentHandle']),
    submit: async function () {
      document.getElementById('buttonDelete').disabled = true;
      document.getElementById('buttonCancelDelete').disabled = true;
      try {
        this.closeHovers();
        this.$store.commit('setReload', true);

        let handle;
        let virtualParentHandle;
        handle = this.req.items[this.selected[0]].handle;
        virtualParentHandle = this.req.items[this.selected[0]].virtualParentHandle;

        this.archiveNestedDrives(handle, virtualParentHandle);
        this.$store.commit('resetSelected');
      } catch (e) {
        this.closeHovers();
        this.$showError(e);
        if (this.isListing) this.$store.commit('setReload', true);
      }
    },
    async archiveNestedDrives (handle, virtualParentHandle) {
      let action = await ibb.archiveSharedDrive(handle);

      let nestedShares = await ibb.getSharedDrives();
      nestedShares = nestedShares.nodeList.filter(item => item.virtualParentHandle === handle);
      
      if (virtualParentHandle !== '') {
        let nodeParent = await ibb.getNodeById(virtualParentHandle);
        if (!nodeParent.node.archived) {
          await ibb.unnestSharedDrive(handle);
        }
      }

      for (let sharedDrive of nestedShares) {
        this.archiveNestedDrives(sharedDrive.handle, sharedDrive.virtualParentHandle);
      }
      if (action.error.type) {
        this.$showError(this.$t('errors.errorArchiveDrive'));
        return;
      }
    },
  },
  beforeDestroy () {
    this.setIsPrompt(false);
    this.setIsRename(false);
  }
};
</script>